import API from '@/services/http'

export interface OneshipTryCalculateResultVo {
  /**服务产品编码, 标准的 */
  expressTypeCode?: string
  /**服务产品名称, 标准的 */
  expressTypeName?: string
  /**渠道服务产品编码 */
  channelExpressType?: string
  /**渠道服务产品名称 */
  channelExpressTypeName?: string
  /**承运商编码 */
  companyCode?: string
  /**承运商名称 */
  companyName?: string
  /** cod */
  supportedCheckoutTypes?: number[]
  /**增值服务：
1=代收货款
2=保价服务
3=包装服务
4=送货上楼
5=保鲜服务
6=返单服务 */
  valueAddedServices?: number[]
  /**承诺送达时间/物流时效 */
  promisedTime?: string
  /**服务产品支持的揽收方式：1:PICK_UP;2:DROP_OFF */
  supportedPickupTypes?: number[]
  /**运费，标准货币单位*100 */
  freight?: number
  /**运费， 货币 */
  currencyCode?: string
  /**
   * 支持的配送类型
   */
  supportedAddressType: string[]
  /**
   * 包裹重量
   */
  weight: number
  discountFreight?: number
  originalFreight?: number
  insuranceSupport: number
  /** 高度/cm */
  height: number
  /** 宽度/cm */
  width: number
  /** 长度/cm */
  length: number
  /** 长宽高单位/cm */
  lengthUnit?: number
  /** 服务产品支持的签收服务类型,目前只有部分签收 SIGN_PART:部分签收 */
  supportSignServiceTypes?: string[]
  /**计费失败原因 */
  failReason?: string
  /**渠道自定义信息，透传给上游, json格式
arriveDaysRange:预估到达时间 eg: 1-4 
"{\"arriveDaysRange\":\"1-4\", \"sendle\":{\"planName\":\"路线\"}}"
*/
  channelCustomParam?: string
  /** 渠道特异性信息序列化而来 */
  channelCustomParamParse?: {
    arriveDaysRange?: string
    sendle?: {
      planName?: string
    }
  }
}

export interface AddressNameVo {
  /**国家编码 */
  countryCode?: string
  /**一级行政区名称，比如省份/州名称 */
  provinceName?: string
  /**一级行政区编码 */
  provinceCode?: string
  /**二级行政区名称，比如城市名称 */
  cityName?: string
  /**二级行政区编码 */
  cityCode?: string
  /**三级行政区名称，比如区/县名称 */
  districtName?: string
  /**三级行政区编码 */
  districtCode?: string

  /**四级行政区名称，街道 */
  townName?: string
  /**四级行政区编码 */
  townCode?: string
  /**邮编 */
  zipCode?: string
}

export interface CalculateRes {
  /**寄件地址 */
  senderAddressName?: AddressNameVo
  /**收件地址 */
  consigneeAddressName?: AddressNameVo
  /**试算结果 */
  calculateResultVos?: OneshipTryCalculateResultVo[]
  /**是否有下一页 */
  hasNext?: boolean
}

export interface CalFreightParamsTypes {
  expressTypeCode?: string
  senderAddressName: {
    countryCode: string
    provinceName: string
    provinceCode: string
    cityName: string
    cityCode: string
    districtName: string
    districtCode: string
    townName: string
    townCode: string
    zipCode: string
  }
  consigneeAddressName: {
    countryCode: string
    provinceName: string
    provinceCode: string
    cityName: string
    cityCode: string
    districtName: string
    districtCode: string
    townName: string
    townCode: string
    zipCode: string
  }
  weight: string
  weightUnit: 'kg' | 'g' | 'lb' | 'oz'
  currencyCode: string
  lastExpressTypeCode?: string
  pageSize?: number
  length?: number
  width?: number
  height?: number
  lengthUnit?: 'cm'
}

/**
 * 运费试算
 * @param params
 * @returns
 */
export const feeTryCalculate = async (params: CalFreightParamsTypes) => {
  const res = await API.admin.post<CalculateRes>('/api/fee/try/calculate', params)
  res?.data?.calculateResultVos?.forEach((item) => {
    try {
      item.channelCustomParamParse = JSON.parse(item.channelCustomParam)
    } catch (error) {}
  })
  return res
}
